import { createApi } from '@reduxjs/toolkit/query/react';
import { waServicesQuery } from './baseQueries';

export interface ConfidenceMeterResponse {
  Image: string;
}

export const mgpApi = createApi({
  reducerPath: 'mgpApi',
  baseQuery: waServicesQuery,
  endpoints: (builder) => ({
    getConfidenceMeter: builder.query<
      ConfidenceMeterResponse,
      { imageWidth?: number; imageHeight?: number } | void
    >({
      query: (args) => {
        const width = args?.imageWidth ?? 300;
        const height = args?.imageHeight ?? 200;
        return {
          url: `/api/investor/mgp/confidencemeter`,
          params: { imageWidth: width, imageHeight: height },
        };
      },
    }),
  }),
});

export const { useGetConfidenceMeterQuery } = mgpApi;
